export const onButtonKeyPress = <T>(handler: (e: React.KeyboardEvent<T> | React.MouseEvent<T>) => void) => (
  e: React.KeyboardEvent<T>
) => {
  if ((e.key === 'Enter' || e.key === ' ') && handler) {
    e.preventDefault();
    handler(e);
  }
};

export const isKeyboardEvent = (e: React.MouseEvent | React.KeyboardEvent): e is React.KeyboardEvent => {
  return 'key' in e;
};

export const stopKeyEvent = (only?: string[], exceptions?: string[]) => (e: React.KeyboardEvent) => {
  if (only && !only.includes(e.key)) {
    return;
  }
  if (exceptions && exceptions.includes(e.key)) {
    return;
  }
  e.stopPropagation();
};
